import { render, staticRenderFns } from "./IssueSelector.vue?vue&type=template&id=6c2b227b&"
import script from "./IssueSelector.vue?vue&type=script&lang=js&"
export * from "./IssueSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports